import type { OfferTravel } from 'BrokerTsLib/src/dtos'
import { createContext, useContext } from 'react'
import { useCalculateOffers, useGetOffers } from '../hooks/useOffer'
import { insuranceParamsContext } from '../layouts/Wizard'
import type { IOffersContext } from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'

export const cestovkoOffersContext = createContext<IOffersContext<OfferTravel>>(defaults as any)

export function CestovkoOffersProvider({ children }: { children: React.ReactNode }) {
  const { insuranceParams, insuranceParamsId } = useContext(insuranceParamsContext) ?? {}

  if (!insuranceParamsId)
    return null

  return (
    <OffersProvider
      insuranceParamsId={insuranceParamsId}
      isContract={!!insuranceParams?.generalParams.contractNumber}
      signalRCalcFinishedEventName='TravelCalcFinished'
      useGetOffers={useGetOffers}
      useCalculateOffers={useCalculateOffers}
      context={cestovkoOffersContext as any}
    >
      {children}
    </OffersProvider >
  )
}

export const useCestovkoOffersContext = () => {
  const context = useContext(cestovkoOffersContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useCestovkoOffersContext must be used within a CestovkoOffersProvider!')
  }

  return context
}